
        module.exports = __webpack_public_path__ + "assets/images/logo-cbam.36eb3478.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 75,
            height: 96,
            type: "svg",
            bytes: 1280,

            toString: function() {
                return src;
            }
        };
    